function n(n,t){return"function"==typeof n?n(t):n&&(n.current=t),n}export{n as assignRef};
//# sourceMappingURL=assignRef.js.map
